import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import addressRegistration01 from "@/assets/images/help/address-registration-01.png";
import addressRegistration02 from "@/assets/images/help/address-registration-02.png";

export default function HelpAddressRegistration() {
  const navigate = useNavigate();

  const steps = [
    {
      title: "Step 1: Start Address Registration",
      description:
        "On the home screen, click the \"Input Address\" button.",
      image: addressRegistration01,
    },
    {
      title: "Step 2: Enter Your Address",
      description: "Fill in your complete address information in the form.",
      image: addressRegistration02,
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-6">
          <h1 className="text-2xl font-bold mb-2">
            User Verification Step 2: Address Registration
          </h1>
          <p className="text-sm text-muted-foreground">
            Follow the instructions below to register your address.
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-8">
          {steps.map((step, index) => (
            <div key={index} className="space-y-4">
              <h3 className="text-lg font-bold opacity-90">{step.title}</h3>
              <p className="text-sm font-semibold whitespace-pre-line">
                {step.description}
              </p>
              <div className="rounded-lg overflow-hidden shadow-md">
                <img
                  src={step.image}
                  alt={`Step ${index + 1}`}
                  className="w-full h-auto"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Completion Note */}
        <div className="mt-8 p-4 bg-primary/5 rounded-lg">
          <h3 className="text-lg font-bold opacity-90 mb-2">
            Step 3: Complete Address Registration
          </h3>
          <p className="text-sm font-semibold whitespace-pre-line">
            Click the "Continue" button to finish registering your address.
            {"\n\n"}
            Proceed to the next step.
          </p>
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/5")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: KYC Verification</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
